define('models/calendar/session/animation',[
    'underscore', 'backbone', 'utils',
    // services
    'services/api',
    // parent
    'src/file-upload-model',
], function(_, Backbone, U, API, FileUploadModel) {

    var MAnimation = FileUploadModel.extend({
        idAttribute: '_id',
        urlRoot: function() {
            var url = "exercises/";

            if (this.isNew()) {
                return API.url("groups/" + this.get('group') + "/" + url);
            }

            return API.url(url);
        },
        blacklist: ["_disabled", "_exercise", "thumbnail", "externalVideo", "group", "zones", "_canWrite"],
        files: ['animation[static]'],
        defaults: function() {
            return {
                animation: {
                    url: null,
                },
                complexName: "",
                description: "",
                name: "",
                thumbnail: "assets/images/default-exercise.jpg",
                columnIndex: 0
            };
        },

        computeds: {
            animationUrl: {
                deps: ['animation'],
                get: function(animation) {
                    return animation ? animation.url : "";
                },
                set: function(url) {
                    var animation = this.get('animation') || {};
                    return {
                        animation: MAnimation.getAnimationObject(url)
                    };
                }
            },

            animationStatic: {
                deps: ['animation'],
                get: function(animation) {
                    return animation ? animation.static : "";
                },
            },

            animationName: {
                deps: ['name', 'complexName'],
                get: function(name, complexName) {
                    return complexName || name;
                },
            },
        },

        unsetStaticAnimation: function() {
            return this.unset('animation[static]');
        },

        setStaticAnimation: function(blob) {
            return this.set('animation[static]', blob);
        },

        getComplexName: function() {
            return this.get('complexName') || this.get("name");
        },

        isDisabled: function() {
            return Boolean(this.get('_disabled'));
        },

        isRenamed: function() {
            return this.get('_isRenamed');
        },

        hasExternalVideo: function() {
            return this.has('animationUrl');
        },

        validation: {
            name: {
                presence: true,
            }
        },

    }, {
        getAnimationObject: function(url) {
            return {
                url: _.isUndefined(url) ? null : url,
                // static: _.isUndefined(static) ? null : static,
            };
        },
    });

    // Return the model for the module
    return MAnimation;
});

